<template>
  <div class="plans">
    <h1><span></span>论文指导</h1>
    <div class="content">
      <div class="topic">
        <div class="topictitle">
          <span>论文题目：</span>{{ title }}
        </div>
        <div class="topiccontent" v-html="remarks">
        </div>
      </div>
      <h2 class="teachetitle">老师指导</h2>
      <div class="message">
        <div v-for="item in chatList" :key="item.id">
          <div class="teachermsg">
            <div class="row">
              <div class="col-md-1">
                <img
                  src="../../../assets/images/nan.jpg"
                  v-if="item.sender === 0"
                  class="header"
                />
              </div>
              <div class="col-md-11">
                <div class="teachername">
                  {{
                  typeof item.sender!=='object'? item.sender === 0 ? '指导老师：' : '我：':''
                  }}<span class="date">{{ item.createTime }}</span>
                </div>
                <div class="teachermsg">
                  {{ item.content }}<br />
                  <span v-if="item.accessory && item.accessoryName"
                  >附件：<span
                    class="download-files"
                    @click="openURL(item.accessory)"
                  >{{ item.accessoryName }}</span
                  ></span
                  >
                </div>
                <!-- <div class="icon">
                  <i class="iconfont icon-huifu1" @click="opens()"></i>
                </div> -->
              </div>
            </div>
          </div>
          <div class="line"></div>
        </div>
        <div class="pagination">
          <a-pagination show-quick-jumper :default-current="1" :total="total" :current="pageNo" :pageSize="pageSize" @change="onChange" />
        </div>
        <div class="answer-teacher">
          <div class="form-horizontal">
            <div class="form-group row">
              <label class="col-md-1 control-label">附件</label>
              <div class="col-md-11">
                <a-upload
                  :file-list="fileList"
                  :before-upload="beforeUpload"
                  accept=".doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                >
                  <button class="btn btn-load">
                    <i class="iconfont icon-wenjianshangchuan1"> </i>
                  </button>
                </a-upload>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-1 control-label">信息</label>
              <div class="col-md-11">
                <textarea
                  rows="5"
                  class="form-control"
                  v-model="content"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-1 control-label"
              >&nbsp;&nbsp;&nbsp;&nbsp;</label
              >
              <div class="col-md-11">
                <button
                  type="submit"
                  :loading="uploading"
                  @click="handleUpload"
                  class="btn btn-default btn-sub"
                >
                  {{ uploading ? '提交中' : '提交' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PlanList',
  props: {
    arrs: Array
  },
  data: function() {
    return {
      pagesize: 10,
      pageNo: 1,
      sex: 1,
      open: false,
      // teacherId: "1325624395947765762",
      teacherId: '',
      chatId: '',
      chatList: null,
      total: 0,
      fileList: [],
      uploading: false,
      content: '',
      titleIds: null,
      teacherIds: null,
      titleId: null,
      title: null,
      remarks: null,
      spinning: false,
      // currentStudent: null,
      websock: null
    }
  },
  computed: {
    // ...mapState(['userInfo']),
    page_arrs() {
      let { currentPage, pagesize } = this
      return this.arrs.slice(
        (currentPage - 1) * pagesize,
        currentPage * pagesize
      )
    },
    current_page() {
      return this.currentPage
    }
  },
  mounted() {
    // this.currentStudent = {
    //   id: '1314384464799592401',
    //   teacherId: '1318732772106219522',
    //   teacherName: '张康辉',
    //   studentId: '1318455174063579137',
    //   realname: '薛奎丽',
    //   status: '对方不在线',
    // }
    this.getThesis()
  },
  methods: {
    getChatList(inexecution) {
      this.axios
        .get(`/biz/thesis/chat/page`, {
          params: {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            teacher_id: this.teacherId
          }
        })
        .then((res) => {
          this.chatList = res.result.records
          this.total = res.result.total
          this.chatId = this.chatList[0].chatId
          if (!inexecution) {
            this.wantGetWebsock()
          }
        })
    },
    getThesis() {
      this.axios.get(`/biz/thesis/time`).then((res) => {
        if (res.success) {
          this.titleIds = res.result.titleIds
          this.teacherIds = res.result.teacherIds
          this.teacherId = res.result.teacherId
          this.titleId = res.result.titleId
          if (this.teacherId && this.titleId) {
            this.titleIds.forEach((element) => {
              if (element.id === this.titleId) {
                this.title = element.title
                this.remarks = element.remarks
              }
            })
          }
          this.getChatList()
        }
      })
    },
    onChange(index) {
      this.pageNo = index
      this.getChatList(true)
    },
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    handleUpload() {
      const { fileList } = this
      console.log(fileList)
      let obj = {
        cmd: 'chitchat',
        toUser: this.teacherId,
        chatId: this.chatId,
        content: this.content,
        sender: 1
      }
      if (fileList.length > 0) {
        const formData = new FormData()
        formData.append('file', fileList[0])
        this.uploading = true
        this.axios.post(`/common/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          if (res.success && res.result) {
            this.uploading = false
            obj.accessory = res.result
            obj.accessoryName = fileList[0].name
            obj.accessorySize = fileList[0].size
            this.websocketSend(obj)
            // obj.createTime = this.format(new Date(), 'yyyy-MM-dd hh:mm:ss')
            // this.chatList.push(obj)
            this.getChatList(true)
            this.content = null
          }
        })
      } else {
        this.websocketSend(obj)
        this.getChatList(true)
        // obj.createTime = this.format(new Date(), 'yyyy-MM-dd hh:mm:ss')
        // this.chatList.push(obj)
        this.content = null
      }
    },
    // chatMethod (result, name, size, message) {
    //   this.axios
    //     .post(`/biz/thesis/chat/student`, {
    //       accessory: result,
    //       accessoryName: name,
    //       accessorySize: size,
    //       content: this.content,
    //       teacherId: this.teacherId,
    //     })
    //     .then((res2) => {
    //       if (res2.success) {
    //         this.fileList = []
    //         this.content = ''
    //         this.getChatList()
    //         this.$message.success(message)
    //       } else {
    //         this.$message.error(res2.message)
    //       }
    //     })
    // },
    openURL(URL) {
      window.location.href = URL
    },
    wantGetWebsock() {
      let timer = setInterval(() => {
        if (this.websock) {
          clearInterval(timer)
        } else {
          this.$bus.$emit('wantGetWebsocketObject')
        }
      }, 1000)
      this.$bus.$on('getWebsocketObject', this.getWebsocket)
      this.$bus.$on('newMessageWillbeReceive', this.websocketOnmessage)
      this.$bus.$on('getStatus', this.changeSatus)
    },
    getWebsocket(websock) {
      this.websock = websock
    },
    websocketOnmessage(data, callback) {
      this.getChatList(true)
      if (this.chatId === data.msgId) {
        // eslint-disable-next-line standard/no-callback-literal
        callback({ status: true })
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        callback({ status: false })
      }
    },
    changeSatus(data) {
      console.log('改变状态')
      // Object.assign(this.tempCurrentStudent, { status: data.hint })
      // this.currentStudent = this.tempCurrentStudent
      // // this.currentStudent.status = data.hint
      // setTimeout(() => {
      //   this.spinning = false
      // }, 500)
    },
    websocketSend(text) {
      // 数据发送
      try {
        const data = JSON.stringify(text)
        this.websock.send(data)
      } catch (err) {
        console.log('send failed (' + err.code + ')')
      }
    }
    // format(date, fmt) {
    //   let o = {
    //     'M+': date.getMonth() + 1, // 月份
    //     'd+': date.getDate(), // 日
    //     'h+': date.getHours(), // 小时
    //     'm+': date.getMinutes(), // 分
    //     's+': date.getSeconds(), // 秒
    //     'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    //     'S': date.getMilliseconds() // 毫秒
    //   }
    //   if (/(y+)/.test(fmt)) {
    //     fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    //   }
    //   for (let k in o) {
    //     if (new RegExp('(' + k + ')').test(fmt)) {
    //       // eslint-disable-next-line eqeqeq
    //       fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    //     }
    //   }
    //   return fmt
    // }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.plans {
  padding-top: 30px;

  h1 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;

    span {
      display: inline-block;
      width: 5px;
      height: 16px;
      background: $bgColor;
      margin-right: 10px;
    }
  }

  .content {
    background: #fff;
    padding: 28px;

    .result {
      background: #f8faf9;
      padding: 20px;
      margin-bottom: 30px;
      color: #999999;

      strong {
        font-weight: bold;
        margin-right: 20px;
        color: #333;
      }
    }
  }

  .btn {
    width: 80px;
    height: 32px;
    line-height: 32px;
    padding: 0;
    background: #cbccce;
    text-align: center;
    color: #fff;
    border: none;
  }

  .active {
    background: $bgColor;
  }

  th {
    text-align: center;
    background: #f6f6f8;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  td {
    text-align: center;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  tr:nth-child(odd) {
    background: #f6f6f8;
  }

  .topictitle {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .topiccontent {
    line-height: 24px;
    padding: 20px;
    color: #999;
    border-radius: 5px;
  }

  .line {
    height: 2px;
    background: #efefef;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .teachetitle {
    font-size: 16px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
    color: $bgColor;
    border-bottom: 2px solid #efefef;
    padding-bottom: 3px;
  }
}

.teachermsg {
  .header {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    border: 1px solid #efefef;
  }

  .teachername {
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 10px;

    .date {
      font-weight: normal;
      color: #999;
      font-size: 13px;
      margin-left: 10px;
    }
  }

  .teachermsg {
    line-height: 24px;
    color: #999;
  }

  .iconfont {
    font-size: 22px;
    color: $bgColor;
  }
}

.studentmsg {
  .teachername {
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 10px;

    .date {
      font-weight: normal;
      color: #999;
      font-size: 13px;
      margin-left: 10px;
    }
  }

  .teachermsg {
    line-height: 24px;
    color: #999;
  }

  .flag {
    display: inline-block;
    width: 5px;
    height: 16px;
    position: relative;
    top: 3px;
    background: $bgColor;
    margin-right: 10px;
    border-radius: 4px;
  }
}

.btn-load {
  border: 1px solid $bgColor !important;
  background: #fff !important;
  color: $bgColor !important;
}

.answer-teacher {
  margin-top: 20px;
  border: 1px solid $bgcontent;
  padding: 28px;
  border-radius: 5px;
}

.btn-sub {
  background: $bgColor !important;
}

.pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  aliitem: center;
}

.download-files {
  color: #2d9dff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/graduationmanagement/components/ChangeStateSecond.vue